export const saveToLocalStorage = async (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

export const removeFromLocalStorage = (key: string) => {
  window.localStorage.removeItem(key);
};

export const getValueFromLocalStorage = (key: string) => {
  return window.localStorage.getItem(key) ?? "";
};
